<template>
  <div class="acc-notif-item margin-top-m">
    <div class="large margin-bottom-xs">
      {{ INBOX.addCardToWallet.walletLabel }}
    </div>
    <p class="margin-bottom-s">
      {{ INBOX.addCardToWallet.saveCreditCard }}
    </p>
    <div class="margin-bottom-m">
      <button type="button" class="acc-notif-button secondary button expanded" aria-label="add a credit card" @click.prevent="addCard">
        {{ INBOX.addCardToWallet.addCardLabel }}
      </button>
    </div>
  </div>
</template>
<script setup>
import { fireTag } from '@vue-util/tagManager';
import { INBOX, WALLET } from 'config';
import { useWalletStore } from '@/stores/useWalletStore';
import { useDashboardStore } from '@/stores/useDashboardStore';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';
import { useProfileStore } from '@/stores/useProfileStore';
import useSlideout from '@/composables/useSlideout';
import { useUserSessionId } from '@/composables/useUserSessionId';

const walletStore = useWalletStore();
const dashboardStore = useDashboardStore();
const envPropsStore = useEnvPropsStore();
const profileStore = useProfileStore();

const { showSlideout, closeSlideout } = useSlideout();
const { userSessionIdInit } = useUserSessionId();

const onCardSubmit = async (response) => {
  const severity = response.walletTender?.msg || 'error';
  if (severity === 'success') {
    await walletStore.fetchCreditCards();
    await dashboardStore.fetchRewardsSummary();
    await dashboardStore.setGlobalNotification({
      type: 'success',
      closeButton: true,
      message: INBOX.addCardToWallet.saveChangesToWallet,
    });
  } else {
    const message = response?.walletTender?.error?.message || '';
    await dashboardStore.setGlobalNotification({
      type: 'error',
      closeButton: true,
      message,
    });
  }
  dashboardStore.resetSlideout();
  closeSlideout(INBOX.addCardToWallet.addCardSlideoutId);
};

const addCard = () => {
  closeSlideout('inbox-slideout');
  showSlideout(
    INBOX.addCardToWallet.addCardSlideoutId,
    'Add Credit Card',
    import('@nuxt-common/payment-cards/app/components/AddEditDeleteCard'),
    true,
    {
      cardAction: 'add',
      callback: onCardSubmit,
      isOnlyMacysOption: false,
      tokenizationIframeSource: envPropsStore.tokenizationIframeSource,
      tokenizationPciIframeSrc: envPropsStore.tokenizationPciIframeSrc,
      deviceType: envPropsStore.deviceType,
      isCheckboxDisable: true,
      userAddress: profileStore.profile?.shippingAddress,
      userEmail: profileStore.profile?.email,
    },
  );
  userSessionIdInit();

  fireTag('link', {
    ...WALLET.tag.addCard,
  });
};
</script>
